<div class="grid-x">
  <div class="cell small-4">
    Target Status
  </div>
  <div class="cell small-8">
    <select [(ngModel)]="sideEffect.configuration.targetStatus">
      @for (status of possibleStatuses; track status) {
        <option [ngValue]="status.id">{{status.display}}</option>
      }
    </select>
  </div>
  <div class="cell small-12">
    <ul>
      <li>
        Use a Target Status of Completed to indicate that the work order is complete and, if the last work order for the flow, the flow is approved.
      </li>
      <li>
        Use a Target Status of Application Approved to indicate that the work order is complete, the application is considered approved, but there are more steps to be taken before the application is considered complete, such as financial assurance documents needing to be returned to the organization.
      </li>
      <li>
        Use a Target Status of Application Rejected to indicate that the work order is complete, but the application is considered rejected.
      </li>
    </ul>

  </div>
</div>